import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu, styled } from '@mui/material';

export const MenuIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  width: '22px',
  height: '24px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  cursor: 'pointer',
}));

export const MenuStyled = styled(Menu, {
  shouldForwardProp: (prop) => prop !== 'isSubMenu',
})(({ theme, isSubMenu }) => ({
  '& .MuiPopover-paper': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.colors.infoBackground,
    left: '0 !important',
    width: '100%',
    maxWidth: '100%',
    borderRadius: 0,
    WebkitBoxShadow: '0 6px 6px 0 rgba(65, 65, 65, 0.5)',
    '-moz-box-shadow': '0 6px 6px 0 rgba(65, 65, 65, 0.5)',
    boxShadow: '0 6px 6px 0 rgba(65, 65, 65, 0.5)',

    ...(isSubMenu && {
      backgroundColor: theme.palette.colors.secondaryBackground,
    }),
  },

  '& .MuiMenu-list': {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 0,
  },
}));
